import SignupButton from '../signup-button/component';
import LoginButton from '../login-button/component';

export default function RightNav(props: { scrolled?: boolean }) {
  const { scrolled = false } = props;
  const buttonStyle = scrolled ? 'white' : undefined;
  return (
    <ul className="flex grow justify-end lg:flex-wrap items-center">
      <li>
        <LoginButton buttonStyle="plain" />
      </li>
      <li>
        <SignupButton buttonStyle={buttonStyle} />
      </li>
    </ul>
  );
}
